<template>
  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    <div class="max-w-6xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="shadow-lg bg-white rounded-lg rounded-b-none p-6">
        <div class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div class="max-w-md w-full space-y-8">
            <div>
              <img
                class="mx-auto h-12 w-auto"
                src="/img/andVet_logo.png">
              <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                愛玩動物看護師 国家試験<br />オンライン模試<br />メール認証完了画面
              </h2>
            </div>
            <div class="mt-16">
              <p class="text-CLIENT_BL text-2xl text-center">メールアドレスの認証が完了しました。</p>
              <p class="text-CLIENT_BL text-md mt-1 text-center">登録完了メールが届いていない場合、迷惑フォルダをご確認ください。</p>
              <p class="text-CLIENT_BL text-2xl mt-2 text-center">5秒後にログイン画面、もしくは学校用ページへ遷移します。お待ちください。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  onMounted,
} from 'vue'

onMounted(() => {
  setTimeout(() => {
    window.location.replace(
      route('clients.login.index'),
    )
  }, 5000)
})
</script>
